import React from 'react';
import { MessageCircle, Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent } from '@/components/ui/card';

const MessagesPage = () => {
  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-3xl font-bold text-primary-900 mb-2">
            Messages
          </h1>
          <p className="text-neutral-600">
            Stay connected with your travel companions
          </p>
        </div>
      </div>
      
      {/* Search */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-neutral-400" />
        <Input
          placeholder="Search messages..."
          className="pl-10"
        />
      </div>
      
      <Card>
        <CardContent className="p-12 text-center">
          <MessageCircle className="h-16 w-16 text-neutral-400 mx-auto mb-4" />
          <h3 className="text-xl font-semibold text-neutral-700 mb-2">
            No Messages Yet
          </h3>
          <p className="text-neutral-500 mb-4">
            Start conversations after joining events
          </p>
          <Button>Discover Events</Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default MessagesPage;
